<div idleDetect class="container">
  <app-loading></app-loading>
  <router-outlet></router-outlet>
</div>